// extracted by mini-css-extract-plugin
export default {"datetime":"ProductTime_datetime__9gDYG"};